import { render } from "./EditarImovel.vue?vue&type=template&id=6ec95199"
import script from "./EditarImovel.vue?vue&type=script&lang=js"
export * from "./EditarImovel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__